import { render, staticRenderFns } from "./FilterProductListCard.vue?vue&type=template&id=e476a260&scoped=true&"
import script from "./FilterProductListCard.vue?vue&type=script&lang=js&"
export * from "./FilterProductListCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterProductListCard.vue?vue&type=style&index=0&id=e476a260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e476a260",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,ProductPrice: require('/vercel/path0/components/product/ProductPrice.vue').default,ProductAuthors: require('/vercel/path0/components/product/ProductAuthors.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
